import { Box, Divider, Text, TextArea } from '@razorpay/blade/components';
import React from 'react';
import { DetailsViewApproveReject } from '../../DetailsViewApproveReject';
import { useWorkflowDetailsView } from 'components/ApprovalWorkflows/MyRequests/useWorkflowDetailsView';
import Timeline from '../Timeline';
import { useWorkflowRequestDetails } from '../useWorkflowRequestDetails';
import { invalidateSalaryRevisionCache } from 'components/ApprovalWorkflows/MyRequests/SalaryRevision/utils';
import { useQueryClient } from 'react-query';
import { SalaryRevisionDetails } from '../../SalaryRevisionDetails';
import { WorkflowRequestsStatusMap } from 'components/ApprovalWorkflows/MyRequests/constants';
import { ErrorResultsTableView } from '../../ErrorResultsTableView';
import { useSelector } from 'react-redux';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';

const PendingApproval = () => {
  const queryClient = useQueryClient();
  const { closeDetailsView, workflowRequestId } = useWorkflowDetailsView();
  const features = useSelector(loggedInUserSelectors.features);
  const isGraphQLEnabled = !!features?.['graphql'];
  const { data, isLoading, isFetching, refetch, isError } = useWorkflowRequestDetails({
    requestId: Number(workflowRequestId),
    isGraphQLEnabled,
  });
  const isTimelineLoading = isLoading || isFetching;

  const showApproveRejectCtas =
    data?.workflow_requests_data.status === WorkflowRequestsStatusMap.pending;

  const onApproveReject = () => {
    closeDetailsView();
    invalidateSalaryRevisionCache(queryClient);
  };

  if (isError) {
    return (
      <ErrorResultsTableView
        onRetry={refetch}
        description={<Box textAlign="center">Couldn’t fetch request details.</Box>}
        isRetrying={isFetching}
      />
    );
  }

  return (
    (<Box display="flex" flexDirection="column" gap="spacing.7">
      <Box display="flex" gap="spacing.2" alignItems="baseline">
        <Text weight="semibold" color="surface.text.gray.subtle">
          Approval
        </Text>
        <Text variant="caption" color="surface.text.gray.muted" size='small'>
          Salary Revision
        </Text>
      </Box>
      {showApproveRejectCtas && (
        <DetailsViewApproveReject
          requestId={Number(workflowRequestId)}
          approveCallback={onApproveReject}
          rejectCallback={onApproveReject}
        />
      )}
      <Timeline workflowRequestDetails={data} isLoading={isTimelineLoading} />
      <Divider width="100%" />
      <SalaryRevisionDetails workflowRequestDetails={data} isLoading={isTimelineLoading} />
    </Box>)
  );
};

export { PendingApproval };
